import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    getBact (request) {
      if (request.mods === undefined) {
        return api.post('/infections/bact/all', request)
      }
      return api.post('/infections/bact/mod', request)
    },

    getPneu (request) {
      if (request.mods === undefined) {
        return api.post('/infections/pneu/all', request)
      }
      return api.post('/infections/pneu/mod', request)
    }
  }
} else {
  module = {
    _try: 0,

    getBact (request) {
      this._try++
      const result = (this._try > 1) ? [] : { err: 'error' }
      return delay(1000)({ data: result })
    }
  }
}

export default module
